var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.724H8.828A8.829 8.829 0 0 1 0 414.896V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828v317.793a8.829 8.829 0 0 1-8.829 8.827z",
    fill: "#ff4b55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffe15a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.728 224.016l-.017.013L97.103 88.277H8.828c-2.146 0-4.041.86-5.571 2.134l215.864 141.428c1.886-2.874 4.121-5.469 6.607-7.823zM212.318 260.523c-.156-1.508-.456-2.973-.456-4.522 0-1.549.3-3.014.456-4.522v.002L0 229.518v52.966l212.318-21.964v.003zM249.139 212.553c2.251-.354 4.511-.691 6.861-.691 2.35 0 4.61.338 6.861.691h-.001l19.623-124.277h-52.966l19.622 124.277zM292.879 231.839L508.744 90.411c-1.531-1.274-3.425-2.134-5.571-2.134h-88.276L286.289 224.03l-.017-.013c2.486 2.353 4.721 4.948 6.607 7.822zM286.272 287.985l.017-.013 128.608 135.753h88.276c2.146 0 4.041-.86 5.571-2.134L292.879 280.162c-1.886 2.874-4.121 5.47-6.607 7.823zM299.682 251.482v-.002c.156 1.507.456 2.973.456 4.522s-.3 3.014-.456 4.522v-.002L512 282.484v-52.966l-212.318 21.964zM262.861 299.448c-2.251.353-4.511.691-6.861.691s-4.61-.338-6.861-.691h.001l-19.623 124.277h52.966l-19.622-124.277zM219.121 280.162L3.256 421.591c1.53 1.274 3.425 2.134 5.571 2.134h88.276l128.608-135.753.017.013c-2.486-2.353-4.721-4.949-6.607-7.823z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 35.31
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMk);
export default __webpack_public_path__ + "static/media/mk.4453b65c40badcf25366c677c153d81a.svg";
export { ForwardRef as ReactComponent };